import Server from '@/service/server'

export default {
  namespaced: true,
  state: {
    userInfo: {}
  },
  getters: {
    userInfo (state: any) {
      return state.userInfo
    }
  },
  actions: {
    loadUserInfo (context: any) {
      var promise = Server.getUserInfo().then((response: any) => {
        context.commit('setUserInfo', response.body.result)
        return response
      })
      return promise
    },
    updateUserInfo (context: any, payload: any) {
      var promise = Server.updateUserInfo(payload).then((response: any) => {
        context.commit('setUserInfo', response.body.result)
        return response
      })
      return promise
    }
  },
  mutations: {
    setUserInfo (state: any, userInfo: any) {
      state.userInfo = userInfo
    }
  }
}
